// Webhook Service für Datenübertragung
const WEBHOOK_URL = 'https://hook.integrator.boost.space/la4dj2n6ifc5yaub4cgw5xm5edls9p5w';

export const sendToWebhook = async (data, type) => {
  try {
    const payload = {
      timestamp: new Date().toISOString(),
      type: type, // 'onboarding', 'feedback', 'contact'
      data: data
    };

    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    console.log('Data sent to webhook successfully:', payload);
    return { success: true, data: payload };
  } catch (error) {
    console.error('Error sending to webhook:', error);
    return { success: false, error: error.message };
  }
};

// Spezifische Funktionen für verschiedene Datentypen
export const sendOnboardingData = (formData) => {
  return sendToWebhook(formData, 'onboarding');
};

export const sendFeedbackData = (feedbackData) => {
  return sendToWebhook(feedbackData, 'feedback');
};

export const sendContactData = (contactData) => {
  return sendToWebhook(contactData, 'contact');
};